import { Time } from "@angular/common";
import { DateTimeFormat } from "../../../shared/pipes/dateTimeFormat.pipe";

export class PTWTablesRecords {
  id?: number;
  PermitId : number;
  RecordType:number;
  IsApproved?:boolean;
  Remarks?:string;
  ValidationTimeFrom?:Date;
  ValidationTimeTo?:Date;
  user: number;
  date?: Date = new Date();
  username?:string;
  designation?:string;
  OtherAffectedRS?:number;
}

export class TRICRecords {
  id?: number;
  PermitId : number;
  RecordType:number;
  NoOfWorkParty:number;
  user: number;
  date?: Date = new Date();
  username?:string;
  Attendee: AttendeeRecords[] = [];
}
export class AttendeeRecords {
  id?: number;
  AttendeeName:string;
  AttendeePosition:string;
  LastRecordId?:number;
}
